






























































































































































































































































































import { CustomerVehicleRefresh, ScreenSize } from '@/main/components/constants';
import _ from 'lodash';
import Vue from 'vue';
import SmsEmailModal from '@/modules/kartoteka/smsEmailModal/SmsEmailModal.vue';
import { EMAIL_TYP_PZN, SMS_TYP_PZN } from '@/modules/kartoteka/smsEmailModal/constants';
import { Row, convertToObjects } from '@/main/utils/table';
import { PageMode } from '@/main/utils/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { openEdit, openList, openSelectList } from '@/main/router/routerPath';
import { DokladNaplnFakturaci } from '@/modules/uctenky/fakturace/constants';
import { EventBus } from '@/main/eventBus';
import { mapMutationsDvm } from '@/main/pages';
import { LayoutPropsEdit } from '@/main/store/@types/edit.d';
import { PageModeMixin } from '@/main/mixins/pageMode';
import mixins from 'vue-typed-mixins';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { makeInjector } from '@/main/utils/vue';
import { getBoundary, parseMultipart } from '@/main/services/multiPartProvider';
import { ERROR } from '@/main/store/actionTypes';
import { Partner } from '@/modules/kartoteka/partner';
import { showAlert } from '@/main/utils/notifications';
import { getTableCount } from '@/main/utils/commonFunctions';
import { formatDate } from '@/main/utils/dateFormatter';

import dayJs from 'dayjs';


import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';


import { apiProvider as reserveApiProvider } from '@/modules/servis/rezervaceND/api';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import InfoSideBar from '#components/dms/InfoSideBar/InfoSideBar.vue';
import DmsBadgeButton from '#components/dms/button/BadgeButton.vue';

import Buttons from './components/Buttons.vue';
import ElsaButtons from './components/ElsaButtons.vue';
import DropButtons from './components/DropButtons.vue';
import PredbeznaCena from './components/PredbeznaCena.vue';
import {
	ZAKAZKA_DRUH_LOCALIZED,
	zakazkaStateLocalized,
	ZAKAZKA_STAV,
	SERVICE_PKG_PARTS,
	SERVICE_PKG_LABOR,
	PRACOVNI_POZICE,
	ZAKAZKA_ND,
	PART_RETURN_REQUEST,
	CommunicationModeEnum,
	ZAKAZKA_DRUH,
	OrderReports,
	REPORT_TYPES,
	CAMPAIGN_DETAILS,
	AdditionalStatus,
	REPEAT_REPAIR_STATUS,
	CANCELLATION_REASON_TYPES,
	NO_DATA_FOUND,
	CANCELLATION_REASONS,

	MANDATORY_CAMPAIGN,
	OPTIONAL_CAMPAIGN,
	ORDER_SUB_TYPES,

	AUDATEX,
	AUDATEX_OPTIONS,
	EGUI_OPTIONS,
	LOAD_SERVICE_ORDER_CONFIRMATION,
	LOAD_SERVICE_ORDER_CONFIRMATION_DETAILED,
	LOAD_SERVICE_ORDER_CONFIRMATION_DETAILED_CUSTOMER,
} from './constants';
import { getNextStavZakazka, getPrevStavZakazka, getStavZakazka } from './utils';
import { apiProvider, kryciDopisTiskUrl, customerCopyRepairOrderReportUrl } from './api';
import { Fakturace } from '../../uctenky/fakturace';
import { store } from './store/edit';
import { ZakazkovyList } from './zakazkovyList';
import PackageSelect from './components/microcomponents/PackageSelect.vue';
import { SPLIT_PARTIES } from './ServiceJobSplitBilling/constants';
import { BILLING_NAVIGATION, LOAD_JOBLIST, PROFORMA_NAVINGATION } from './zakazkovyList/constants';

const collectionPropInjector = makeInjector<{ mainPageRefresh(): void }>();

export default mixins(PageModeMixin, EditStoreMixin, collectionPropInjector(Vue, ['mainPageRefresh'])).extend({
	name: 'ServisEditLayout',
	components: {
		PredbeznaCena,
		PackageSelect,
		Buttons,
		ElsaButtons,
		DmsBadgeButton,
		InfoSideBar,
		DmsPdfDialog,
		SmsEmailModal,
		DropButtons,
	},
	props: {
		showPredbeznaCena: {
			type: Boolean,
		},
		layoutProps: {
			type: Object as () => LayoutPropsEdit,
			required: true,
		},
		changeTyp: {
			type: String,
		},
	},
	data() {
		return {
			isAudaTexVisible: false,
			lblAudatex: 'LBL_AUDATEX',
			message: 'message',
			lstOrdersButtons: [
				{
					labelKey: null as string | Function | null,
					badge: false as boolean | null,
					value: 0 as number | null,
					click: '' as string | null,
					param: '' as any | boolean | string | null,
					class: '' as string | null,
					disable: '' as string | boolean | null,
					exist: '' as any | boolean | null,
				},

			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			notificationDialog: {
				showNotificationDialog: false,
				notificationDialogMsg: '',
			},
			approvalStatusDialog: {
				visible: false,
				notificationDialogMsg: null as string | null,
				handleClose: () => {},
			},
			showApprovalDialog: false,
			isRevisitApplicable: false,
			showCertifikatTiskDialog: false,
			emailTypPzn: EMAIL_TYP_PZN.ROZPRACOVANA_ZAKAZKA,
			smsTypPzn: SMS_TYP_PZN.ROZPRACOVANA_ZAKAZKA,
			visibleSmsEmailModal: false,
			kryciDopisTiskUrl,
			customerCopyRepairOrderReportUrl,
			showDialog: false,
			showKryciDopisTiskDialog: false,
			showDialogConfirmPkg: false,
			infoSidebarSlotApproved: false,
			isPartReturnDisplay: false,
			isAudatexListShow: false,
			visibleColumns: new Set(['ND_NR', 'TEXT', 'STAV']),
			multipleSelection: [],
			isItemLocked: false,
			isMarkAsPrint: false as boolean | null,
			reportType: '' as string,
			cancellationDialog: false,
			CancellationRemarkInDialog: '' as string | null,
			isCancellationRemarkVisible: false,
			iseGUIVisible: false,
			lbleGUI: 'EGUI',
			eGUIMessage: this.LocalizeChyboveHlasky('EGUIInvoiceNumber'),
			iseGUIIssuePopUpVisible: false,
			rdbCarrier: '' as string | null,
			rdbEcpayCarrier: '' as string | null,
			// rdbBarCodeCarrier: '' as string | null,
			barCode: '' as string | null,
			// rdbCertificateCarrier: '' as string | null,
			digitalCertificate: '' as string | null,
			// rdbDonateCarrier: '' as string | null,
			loveCode: '' as string | null,
			// buyerCompanyTaxId: '' as string | null,
			// buyerCompanyName: '' as string | null,
			filteredValues: [] as any[],
			EguiInvoiceRemark: '' as string | null,
			isSavingCampaign: false,
		};
	},
	inject: {
		mainPageRefresh: 'refreshPage',
	},
	watch: {
		async viewDialogCampaign(newVal) {
			if (newVal) {
				if (this.CampaignData.length && !this.isViewCampaignBtnClicked) {
					await Promise.all([
						(this.zakazkaEditBaseComponent as any).fetchTableSchema([CAMPAIGN_DETAILS]),

					]);
					this.dependentTables.Campaign.rows = this.CampaignData.map((row: any) => objectToCamelCaseShallow(row)) as Row[];
				}
				this.isViewCampaignBtnClicked = false;
				this.CampaignTable = convertToObjects(this.dependentTables.Campaign) as any[];
				this.mandatoryCampaignCount = this.CampaignTable.filter(x => x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN).length;
				if (this.isEditMode && this.ZakazkaId) {
					this.SelectedCampaign = this.CampaignTable.find(x => x.IsSelected)?.ID ?? null;
				}
				if (this.mandatoryCampaignCount === 1) {
					this.SelectedCampaign = this.CampaignTable.find(x => x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN)?.ID ?? null;
					if (this.isCreateMode) {
						this.SelectedCampaignId = this.SelectedCampaign;
					}
				}
			}
		},
	},
	computed: {
		getWidth() :string {
			return this.windowWidth <= +this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : '80%';
		},
		audatexActions(): any {
			const audatexActions = {
				sendToAudatex: 'RBSendToAudatex',
				downloadResultFromAudatex: 'RBDownloadResultFromAudatex',
				retrieveAudatexTaskList: 'RBRetrieveAudatexTaskList',
			};
			return audatexActions;
		},
		..._.omit(genVuexComputeds(store), ['operations', 'validationRules']),
		eGUIActions(): any {
			return {
				printInvoice: 'EGUI_PRINT',
			};
		},
		orderButtons(): object {
			return this.lstOrdersButtons
				.filter((item) => item.labelKey !== undefined && item.labelKey != null && item.exist)
				.map((item) => ({
					labelKey: item.labelKey,
					badge: item.badge,
					value: item.value,
					click: () => { this.call(item.click, item.param); },
					exist: item.exist,
					disable: item.disable,
					class: item.class,
				}));
		},

		isEguiOptionsVisible(): boolean {
			return this.lbleGUI === 'issueInvoice';
		},

		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},

		infoSidebarSlot(): HTMLFormElement {
			return (this.$slots as HTMLFormElement).sideBarContent;
		},
		nahradniDilyTable(): any {
			const copy = _.cloneDeep(this.dependentTables.ZakazkaNd);
			_.forEach(copy.columns, (col) => {
				col.isVisible = this.visibleColumns.has(col.columnName);
			});
			_.forEach(copy.rows, (row) => {
				row.cells[this.dependentTables.ZakazkaNd.cellNames!.STAV!] = row.cells[this.dependentTables.ZakazkaNd.cellNames!.X_STAVVJ!];
			});
			return copy;
		},
		zakazkaNd(): string {
			return ZAKAZKA_ND;
		},
		enableProforma(): boolean {
			return this.NabidkaPrp || this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA;
		},
		disableSP(): boolean {
			return [ZAKAZKA_STAV.UVOLNENA, ZAKAZKA_STAV.V_PRIPRAVE].includes(this.zakazkaStav);
		},
		fakturaceType(): DokladNaplnFakturaci {
			return this.zakazkaStav === ZAKAZKA_STAV.NABIDKA ? DokladNaplnFakturaci.NABIDKA : DokladNaplnFakturaci.PRO_FORMA;
		},
		proformaLabelKey(): string {
			return this.NabidkaPrp ? 'cmdPrint' : 'cmdProforma';
		},
		zakazkaStav(): ZAKAZKA_STAV {
			return getStavZakazka(this.edit);
		},
		localizedDruh(): string {
			return this.LocalizePopisostatni((ZAKAZKA_DRUH_LOCALIZED as Record<string, string>)[this.ZakazkaDruh!]);
		},
		localizedStav(): string {
			return this.LocalizePopisostatni(zakazkaStateLocalized(getStavZakazka(this.edit) == ZAKAZKA_STAV.V_PRIPRAVE && !this.dmsSys.IsPreparationActivePrp ? ZAKAZKA_STAV.OTEVRENA : getStavZakazka(this.edit)));
		},
		localizedHeader(): string {
			return `${this.localizedDruh} (${this.edit.ZakazkaNr}) - ${this.localizedStav}`;
		},
		iscancellationButtonVisible(): boolean {
			return this.Stav === ZAKAZKA_STAV.UVOLNENA && getTableCount(this.dependentTables?.ZakazkaNd, this.PartsCount) < 0;
		},
		mainForm(): HTMLFormElement {
			return this.$children[0] ? (this.$children[0] as any).mainForm : null;
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		isRefreshButtonVisible(): boolean {
            return this.ZakazkaId! > 0 && this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND ;
		},
		zakazkaEditBaseComponent(): Vue {
			return this.$parent.$parent;
		},
		havePolozky(): boolean {
			return (
				getTableCount(this.dependentTables?.ZakazkaNd, this.PartsCount) > 0
                || getTableCount(this.dependentTables?.ZakazkaCiziVykony, this.ExtLaborCount) > 0
                || getTableCount(this.dependentTables?.ZakazkaPracovniPozice, this.LaborsCount) > 0
			);
		},
		vicePackagePrp() : boolean {
			if (this.dmsSys.ServicePackagePrp) {
				return this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_PULT;
			}
			return false;
		},
		enableCancelReschedule(): boolean {
            if (!this.dmsSys.CancelOrRescheduleOrdrPrp) {
                return false;
            }
            return this.zakazkaStav === ZAKAZKA_STAV.V_PRIPRAVE;
        },
        enableGatePass(): boolean {
            if (!this.dmsSys.CancelOrRescheduleOrdrPrp) {
                return false;
            }
            if ([ZAKAZKA_STAV.UVOLNENA, ZAKAZKA_STAV.UZAVRENA].includes(this.zakazkaStav)) {
                return false;
            }
            if (this.IsGatePassAvailable) {
                return true;
            }
            return this.zakazkaStav === ZAKAZKA_STAV.VYRAZENA;
		},

		gdprTiskFilter(): { Id: any } {
			return {
				Id: this.ZakazkaId,
			};
		},

		isSalesCounter() : boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_PULT;
		},

		isWorkItemVisible() : boolean {
			if (this.dmsSys.WorkItemPrp) {
				return this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT;
			}
			return false;
		},
		isOrderReleasedOrClosed(): boolean {
			return (this.OrderSubtypeId === ORDER_SUB_TYPES.PDI_V || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.UZAVRENA || this.isViewMode);
		},
		iseGUIApplicable(): boolean {
			return (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.UZAVRENA) && (this.EGUIInvoiceNumber !== '' && this.EGUIInvoiceNumber !== null);
		},
	},
	async mounted() {
		this.lstOrdersButtons = [
			{ labelKey: this.proformaLabelKey, badge: false, value: 0, click: 'onFakturace', param: this.fakturaceType, disable: !this.enableProforma, exist: true, class: 'btn-height' },
			{
				labelKey: 'ShowMsg',
				badge: true,
				value: this.NoticeList && this.NoticeList?.length > 0 ? this.NoticeList?.length : 0,
				click: 'showInfoMsg',
				param: '',
				disable: false,
				exist: this.infoSidebarSlot,
				class: 'btn-height',
			},
			{
				labelKey: 'btnCancelOrder',
				badge: false,
				value: 0,
				click: 'cancelOrRescheduleOrder',
				param: '',
				disable: !this.enableCancelReschedule,
				exist: this.zakazkaExists && !this.iscancellationButtonVisible,
				class: 'btn-height',
			},
			{
				labelKey: 'btnRescheduleOrder',
				badge: false,
				value: 0,
				click: 'rescheduleOrder',
				param: '',
				disable: !this.enableCancelReschedule,
				exist: this.zakazkaExists,
				class: 'btn-height',
			},
			{ labelKey: 'cmdSMSEmail', badge: false, value: 0, click: 'sendSmsEmail', param: '', disable: false, exist: this.zakazkaExists, class: 'btn-height' },
			{
				labelKey: 'CancelOrder',
				badge: false,
				value: 0,
				click: 'onCancelClick',
				param: '',
				disable: false,
				exist: this.iscancellationButtonVisible && this.dmsSys.Parts_Order_Cancel_Prp,
				class: 'btn-height',
			},
		];

		const debounceResize = _.debounce(() => {
			this.windowWidth = window.innerWidth;
		}, 200);
		window.addEventListener('resize', debounceResize);

		if (this.isZakazkaDisabled) {
			this.isZpracuj = true;
			EventBus.$emit('DisableAll', true);
		}

		const promises = [];
		if (this.Oznam) {
			this.notificationDialog.notificationDialogMsg = this.Oznam;
			this.notificationDialog.showNotificationDialog = true;
		}
		if (this.IsWatchlisted && this.loggedUser.DmsSys.WatchlistedApprovalPrp) {
			this.notificationDialog.showNotificationDialog = true;
			this.notificationDialog.notificationDialogMsg = this.edit.IsWatchlistedRejected
				? this.LocalizeChyboveHlasky('RejectWatchlistedOrder')
				: this.LocalizeChyboveHlasky('AddwatchlistedOrderStatus');
		}
		if (this.AdditionalJobStatus === AdditionalStatus.IsAdded || this.AdditionalPartStatus === AdditionalStatus.IsAdded) {
			this.infoSidebarSlotApproved = true;
		}
		if (!this.isCreateMode) {
			promises.push(apiProvider.getPrice(this.ZakazkaId!).then(response => {
				this.CenaCelkem = response.data;
			}));
			promises.push(reserveApiProvider.getSectionPartDiscount(this.ZakazkaId!).then(response => {
				this.TotDiscPercentParts = response.data || null;
			}));
		}
		await Promise.all(promises);
	},
	methods: {
		mandatoryCampaignCheckBeforeClose(done: () => void) {
			if (this.isMandatoryCampaignSaved() || (this.SelectedCampaignId !== null && this.isCreateMode)) {
				done();
			} else if (this.mandatoryCampaignCount && (!this.isMandatoryCampaignSelected() || (this.SelectedCampaignId === null && this.isCreateMode))) {
				this.showErrorAlert({ message: 'InvalidCampaign' });
			} else {
				done();
			}
		},
		...mapMutationsDvm(store.mutations),
		call(method:any, args:any) {
			(this as { [key:string]:any })[method](args as any);
		},
		sendSmsEmail() {
			this.visibleSmsEmailModal = true;
		},
		showInfoMsg() {
			this.showInfoSideBar = !this.showInfoSideBar;
		},
		onChangeCancelType(value: any) {
			this.isCancellationRemarkVisible = value === CANCELLATION_REASONS.OTHER;
		},
		async onBlurHandler() {
			if (this.TotalCostLimit) {
				this.showApprovalDialog = true;
			}
		},
		onRevisitSelection() {
			this.isRevisitApplicable = this.RrStatusCode === REPEAT_REPAIR_STATUS.OTHER;
			if (!this.isRevisitApplicable) {
				this.RrDescription = '';
			}
		},
		editpartreturnClick() {
			this.showErrorAlert({ message: 'PartReturnRequestEditView' });
			return false;
		},
		viewpartreturnClick() {
			this.showErrorAlert({ message: 'PartReturnRequestEditView' });
			return false;
		},
		async onCommModeSelection() {
			if (this.CommunicationModeId! > 0) {
				const { data: isCommunicationModeAvailable } = await Partner.apiProvider.checkCustomerMode(this.edit.ZakaznikId!, this.CommunicationModeId!);
				if (!isCommunicationModeAvailable) {
					if (this.CommunicationModeId === CommunicationModeEnum.EMAIL) {
						this.showErrorAlert({ message: 'CUST_COMMUN_MODE_EMAIL' });
					} else if ([CommunicationModeEnum.SMS, CommunicationModeEnum.WhatsApp].includes(this.CommunicationModeId!)) {
						this.CommunicationModeId = CommunicationModeEnum.EMAIL;
						this.showErrorAlert({ message: 'CUST_COMMUN_MODE_SMS' });
					}
				}
			}
		},
		handleSelection(rows: []) {
			this.multipleSelection = rows;
		},
		async isPartLocked() {
			this.startLoading();
			try {
				const editBase = this.zakazkaEditBaseComponent as any;
				const hasSchema = this.dependentTables.ZakazkaNd?.columns?.length > 0;
				const hasData = hasSchema && this.dependentTables.ZakazkaNd?.rows?.length >= 0;

				editBase.allowHeavyFetch = true;
				if (!hasSchema) {
					await editBase.fetchTableSchema([ZAKAZKA_ND]);
				}
				if (!hasData) {
					await editBase.fetchTableData([ZAKAZKA_ND]);
				}

				this.isItemLocked = this.dependentTables.ZakazkaNd.rows.some(
					row => row.cells[this.dependentTables.ZakazkaNd.cellNames!.IS_LOCKED!]
				);

				if (this.isItemLocked) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('PartLocked'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'error' },
					});
					return;
				}

				this.isPartReturnDisplay = true;
			} finally {
				this.endLoading();
			}
		},
		// getsplitData(itemIds: any[]) {
		// 	this.startLoading();
		// 	try {
		// 		if (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA) {
		// 			itemIds.forEach((itemId, index) => {
		// 				apiProvider.getSplitDetails(itemId, this.ZakazkaId)
		// 					.then(response => {
		// 						if (response && response.data && response.data.length > 0) {
		// 							response.data.forEach((k: any) => {
		// 								if (k.PartyType === SPLIT_PARTIES.Warranty || k.PartyType === SPLIT_PARTIES.Goodwill) {
		// 									this.dependentTables.ZakazkaNd.rows.splice(index, 1);
		// 								}
		// 							});
		// 						}
		// 					});
		// 			});
		// 		}
		// 	} finally {
		// 		this.endLoading();
		// 	}
		// },
		async invoiceLocked() {
			this.startLoading();
			try {
			const editBase = this.zakazkaEditBaseComponent as any;
			const hasSchema = this.dependentTables.ZakazkaNd?.columns?.length > 0;
			const hasData = hasSchema && this.dependentTables.ZakazkaNd?.rows?.length >= 0;

			editBase.allowHeavyFetch = true;
			if (!hasSchema) {
				await editBase.fetchTableSchema([ZAKAZKA_ND]);
			}
			if (!hasData) {
				await editBase.fetchTableData([ZAKAZKA_ND]);
			}
			}
			finally {
				this.endLoading();
			}
			this.isItemLocked = this.dependentTables.ZakazkaNd.rows.some(
				element => element.cells[this.dependentTables.ZakazkaNd.cellNames!.IS_LOCKED!] === true
			);
			
		},
		async canReturnPart(selectedValues: any[], selectedValuesWithIndex: any[][]) {
			this.startLoading();
			try {
				const { data: partReturnCheck } = await apiProvider.canReturnPart(selectedValues,this.ZakazkaId);
				if (!partReturnCheck.canReturnPart && this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA && this.IsOrderSentToSaga === true) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PartReturnValidation') });
				} else if (partReturnCheck.isPartBilled) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('BilledPartValidation') });
				} else {
					this.isPartReturnDisplay = false;
					localStorage.selectedValues = selectedValuesWithIndex;
					openEdit(PART_RETURN_REQUEST, PageMode.CREATE, {
						props: true,
						filter: { OrderNo: this.ZakazkaId, OrderId: this.ZakazkaNr },
					});
				}
			} finally {
				this.endLoading();
			}
		},
		getSelectedParts() {
			const idColumnIndex = this.nahradniDilyTable!.cellNames!.idColumn;
			const checkboxColumnIndex = this.nahradniDilyTable!.cellNames!.CHECKBOX;
			const selectedValues = this.multipleSelection.map((s: any) => [s.cells[idColumnIndex]]);
			if (selectedValues.length === 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PartsReturn'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			} else {
				const selectedValuesWithIndex = this.multipleSelection.map((s: any) => [s.cells[idColumnIndex], s.cells[checkboxColumnIndex]]);
				this.canReturnPart(selectedValues, selectedValuesWithIndex);
			}
		},
		getAudatexList() {
			this.isPartReturnDisplay = false;
		},
		nextStav() {
			return getNextStavZakazka(this.edit, this.dmsSys.IsPreparationActivePrp);
		},
		prevStav() {
			return getPrevStavZakazka(this.edit);
		},
		async onFakturace(type: DokladNaplnFakturaci = DokladNaplnFakturaci.DRUHY_DD, isProforma = false, isBillingScreen = false) {

			const {data:billingDataArray} = await apiProvider.navigateToBillingScreen(this.ZakazkaId!,isBillingScreen);``
			const startTime = performance.now();
			let dokladType = type;

			if (this.dmsSys.WorkItemPrp && type === DokladNaplnFakturaci.DRUHY_DD
				&& (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA) && this.VozidloId != null) {
				if (billingDataArray && billingDataArray.length && billingDataArray.every((x: any) => !x.OverAllLineItemCompletionStatus)) {
					this.showErrorAlert({ message: 'orderNotCompletedYet' });
					return;
				}
			}
			const billingData = billingDataArray && billingDataArray.length ? billingDataArray[0] : {};
			if (this.dmsSys.WorkItemPrp && this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT && type === DokladNaplnFakturaci.DRUHY_DD && this.IsAllItemLevelStatusEntered !== true
				&& this.ZakazkaDruh !== ZAKAZKA_DRUH.DILENSKA
				&& (this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_ZBOZI || (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI && this.VozidloId === null))) {
				if (this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND) {
					this.showErrorAlert({ message: 'orderNotCompletedYet' });
					return;
				}
			}

			const nemaZuctovatelnePolozky =
				getTableCount(this.dependentTables?.ZakazkaNd, this.PartsCount) === 0
				&& getTableCount(this.dependentTables?.ZakazkaPracovniPozice, this.LaborsCount) === 0
				&& getTableCount(this.dependentTables?.ZakazkaCiziVykony, this.ExtLaborCount) === 0
				&& getTableCount(this.dependentTables?.ZakazkaPneu, this.ZakazkaPneuCount) === 0
				&& getTableCount(this.dependentTables?.ZakazkaZapujcka, this.ZakazkaZapujckaCount) === 0;

			const isSalesCounterOrder = getTableCount(this.dependentTables?.ZakazkaNd, this.PartsCount) === 0 && this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_PULT;
			if (isSalesCounterOrder && this.dmsSys.Parts_Order_Cancel_Prp && (this.edit.CancellationReasonType === null || this.edit.CancellationReasonType === 0)) {
				this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('CancellationReason');
				this.notificationDialog.showNotificationDialog = true;
				this.edit.IsCancellationReason = true;
				return;
			}

			if (this.dmsSys.OrderDiscountPrp && type !== DokladNaplnFakturaci.PRO_FORMA) {
				this.CenaCelkem = billingData.orderTotalAmount;
				if (this.CenaCelkem! <= 0) {
					dokladType = DokladNaplnFakturaci.REF_DOC;
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('ZeroInvoice'),
						localizeMessage: false,
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					});
				}

				await this.invoiceLocked();
				if (this.isItemLocked) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('PartLocked'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'error' },
					});
					return;
				}
			}

			if (nemaZuctovatelnePolozky) {
				this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('EmptyPoloz');
				this.notificationDialog.showNotificationDialog = true;
				return;
			}

			if (this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_ZBOZI && this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND && isBillingScreen) {
				const kmStav  = billingData.KmStav;
				if (kmStav === null || kmStav === undefined) {
					this.showErrorAlert({
						message: `${this.LocalizeChyboveHlasky('CreateZL')}`,
						localizeMessage: false,
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					});
					return;
				}
			}
			 
			if (this.dmsSys.GenerateQuotationPrp && this.NabidkaPrp) {
				if ([ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.KULANCE].includes(this.ZakazkaDruh!)) {
					dokladType = DokladNaplnFakturaci.QUICK_ESTIMATE;
				}
				if ([ZAKAZKA_DRUH.PRODEJ_PULT, ZAKAZKA_DRUH.PRODEJ_ZBOZI].includes(this.ZakazkaDruh!)) {
					dokladType = DokladNaplnFakturaci.SALE_QUOTE;
				}
			}

			const dokladNaplnFakturaci = dokladType;
			this.startLoading();
			try {
				await apiProvider.saveDeliveryStartTime(this.ZakazkaId);
				openEdit(Fakturace.name, PageMode.CREATE, {
					filter: {
						zakazkaId: this.ZakazkaId,
						dokladNaplnFakturaci,
						createdById: this.VstupPracId,
						zakazkaDTO: this.edit,
						isProforma,
						isBillingScreen
					}
				});
			} finally {
				this.endLoading();
			}
			const endTime  = performance.now() - startTime;
			let seconds = parseFloat((endTime / 1000).toFixed(2));
			if (!isBillingScreen) {
				await apiProvider.logPerformance('OrderPrp', `Order:${this.ZakazkaId}`, PROFORMA_NAVINGATION, seconds);
			}
			else {
				await apiProvider.logPerformance('OrderPrp', `Order:${this.ZakazkaId}`, BILLING_NAVIGATION, seconds);
			}
		},
		async onCancelClick() {
			if (!this.edit.CancellationReasonType || this.edit.CancellationReasonType === CANCELLATION_REASON_TYPES.NOT_APPLICABLE) {
				this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('CancelltionReasonrequired');
				this.notificationDialog.showNotificationDialog = true;
				this.edit.IsCancellationReason = true;
				return;
			}

			if (this.edit.CancellationReasonType === CANCELLATION_REASON_TYPES.OTHER && !this.edit.CancellationReason) {
				this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('CancelltionRemarksrequired');
				this.notificationDialog.showNotificationDialog = true;
				this.edit.IsCancellationReason = true;
				return;
			}

    		const isCancellationConfirmed = await this.showConfirmPokracovat(this.LocalizeChyboveHlasky('CancelConfirmation'), false);
			if (isCancellationConfirmed) {
				this.edit.IsCancellationReason = true;
				this.startLoading();
				try {
					const result = await apiProvider.cancelOrder(this.edit);
					if (result.data) {
						await this.layoutProps.deleteClick();
					}
				} finally {
					this.endLoading();
				}
			}
		},
		async approveAdditionalAmount() {
			this.showApprovalDialog = false;
			this.startLoading();
			try {
				const { data: isApproved } = await apiProvider.approveAdditionalAmount(this.ZakazkaId);
				if (isApproved) {
					this.approvalStatusDialog.visible = true;
					if (this.edit.CenaCelkem! > this.edit.TotalCostLimit!) {
						this.edit.TotalCostLimit = this.edit.CenaCelkem;
					}
					this.edit.OldTotalPrice = this.edit.CenaCelkem;
					this.approvalStatusDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('AddAmountApprovalStatus');
				}
			} finally {
				this.endLoading();
			}
		},
		async rejectAdditionalAmount() {
			this.TotalCostLimit = 0;
			this.TotalLimitRemark = '';
			this.showApprovalDialog = false;
		},
		async onDialogKryciDopisShow() {
			this.tiskDialog.url = kryciDopisTiskUrl;
			this.tiskDialog.filter = {
				ZakazkaId: this.ZakazkaId,
				ReportType: 'pdf',
			};
			if (!this.zakazkaExists) {
				await (this.zakazkaEditBaseComponent as any).changeToEdit();
			} else {
				await (this.zakazkaEditBaseComponent as any).save(false);
			}
			this.tiskDialog.visible = true;
			this.showApprovalDialog = true;
		},
		showTiskOpravyPoNehodach() {
			this.tiskDialog.filter = {
				ZakazkaId: this.ZakazkaId,
				ReportType: 'pdf',
			};
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.specialistaOpravReport(filter);
			this.tiskDialog.visible = true;
		},
		showTiskCertDialog() {
			this.tiskDialog.filter = {
				Id: this.ZakaznikId,
				VyrobekVoz: this.VyrobekvozOzn,
				PrintDialog: true,
				ReportType: 'pdf',
			};
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.certSpecOprReport(filter);
			this.tiskDialog.visible = true;
		},
		showTiskPneuDialog() {
			this.tiskDialog.filter = {
				Id: this.ZakazkaId,
				IsCopy: false,
				IsView: false,
				ReportType: 'pdf',
			};
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.getPneuPredavaciProtokolServisReport(filter);
			this.tiskDialog.visible = true;
		},
		async showGenerateGatePass() {
			const { data: LaborCompleted } = await apiProvider.IsVasAndWashingLaborComplete(this.ZakazkaId!);
			if (!LaborCompleted) {
				this.showErrorAlert({ message: 'PENDING_VAS_WASHING_MSG' });
				return;
			}
			this.tiskDialog.filter = {
				Id: this.ZakazkaId,
				IsCopy: false,
				IsView: false,
				ReportType: 'pdf',
			};
			this.reportType = REPORT_TYPES.GatePass;
			this.isMarkAsPrint = true;
			this.tiskDialog.fetchPdfProvider = () => apiProvider.generateGatePass(this.ZakazkaId!);
			this.tiskDialog.visible = true;
		},
		async onZakazkovyListClick() {
			if (this.dmsSys.IsCommMode_IsDocConf_Prp) {
				const valid = await (this.zakazkaEditBaseComponent as any).customValidation();
				if (!valid) {
					return;
				}
			}
			this.startLoading();
			try {
				const mode = (this.isEditMode && !this.isZpracuj) || this.isCreateMode ? PageMode.EDIT : PageMode.VIEW;
				await (this.zakazkaEditBaseComponent as any).changeToEdit();
				const zakazkaListId = mode === PageMode.VIEW && this.ZakazkaListId
					? this.ZakazkaListId
					: (await ZakazkovyList.apiProvider.getOrCreate(this.ZakazkaId!)).data;
				await openEdit(ZakazkovyList.name, mode, { id: zakazkaListId, filter: { VozidloId: this.VozidloId, ZakazkaId: this.ZakazkaId } });
			} catch (e) {
				console.error(e);
			} finally {
				this.endLoading();
			}
		},
		async deleteClick() {
			this.CancellationRemarkInDialog = this.CancellationRemarks;
			if (this.CancellationRemarkInDialog && this.OthersType! > 0 && this.CancellationRemarkInDialog.includes('-')) {
				this.CancellationRemarkInDialog = this.CancellationRemarkInDialog.split('-')[1].trim();
			}
			this.cancellationDialog = true;
		},
		async validateAndProceedCancellation() {
			if (this.OthersType! === CANCELLATION_REASONS.OTHER && (!this.CancellationRemarkInDialog || this.CancellationRemarkInDialog.trim() === '')) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('CancelRemarks'),
					localizeMessage: false,
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: { type: 'error' },
				});
				return;
			}

			this.CancellationRemarks = this.CancellationRemarkInDialog;
			if (this.OthersType! === CANCELLATION_REASONS.OTHER && (!this.CancellationRemarks || this.CancellationRemarks === '')) {
				showAlert({
					message: this.LocalizeChyboveHlasky('CancelRemarks'),
					title: this.LocalizeChyboveHlasky('DMS3_CancelComment'),
					options: {
						type: 'info',
					},
				});
				return;
			}

			this.cancellationDialog = false;
			if (this.CancellationRemarks && !this.havePolozky) {
				this.discardOrder();
			} else if (!this.CancellationRemarks && this.OthersType! === CANCELLATION_REASONS.OTHER) {
				this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('ErrPoznamkaEmpty');
				this.layoutProps.validationRules = { ...this.layoutProps.validationRules, CancellationRemarks: { required: true } };
				this.notificationDialog.showNotificationDialog = true;
			} else if (getTableCount(this.dependentTables?.ZakazkaNd, this.PartsCount) > 0
						|| getTableCount(this.dependentTables?.ZakazkaCiziVykony, this.ExtLaborCount) > 0) {
				this.CancellationRemarks = '';
				this.CancellationRemarkInDialog = '';
				this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('ExistPolInZak');
				this.notificationDialog.showNotificationDialog = true;
			} else if (getTableCount(this.dependentTables?.ZakazkaPracovniPozice, this.LaborsCount) > 0) {
				const { data: laborStarted } = await apiProvider.IsLaborOperationStarted(this.ZakazkaId!);
				if (laborStarted) {
					this.CancellationRemarks = '';
					this.CancellationRemarkInDialog = '';
					this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('ExistPolInZak');
					this.notificationDialog.showNotificationDialog = true;
				} else {
					this.discardOrder();
				}
			} else {
				this.discardOrder();
			}
		},
		async discardOrder() {
			this.startLoading();
			await this.layoutProps.saveClick();
			if (this.loggedUser.DmsSys.WarrantyPrp) {
				if (this.CancellationRemarks?.includes('-')) {
					this.CancellationRemarks = this.CancellationRemarks.split('-')[1].trim();
				}
				await apiProvider.discardOrder(this.ZakazkaId!, this.CancellationRemarks || '', this.OthersType!);
				this.endLoading();
				openList('Zakazka');
			} else {
				await this.layoutProps.deleteClick();
			}
			this.endLoading();
		},
		async onSearchClick() {
			if (!this.ServicePackageId) return;

			this.startLoading();
			this.showDialogConfirmPkg = true;
			try {
				await Promise.all([
					(this.zakazkaEditBaseComponent as any).fetchTableSchema([SERVICE_PKG_PARTS, SERVICE_PKG_LABOR]),
					this.fetchTableData([SERVICE_PKG_PARTS, SERVICE_PKG_LABOR])
				]);
			} finally {
				this.endLoading();
			}
		},
		async onViewCampaignClick() {
			if (this.OrderSubtypeId === ORDER_SUB_TYPES.PDI) {
				this.showErrorAlert({ message: 'CampaignNotApplicableAlert' });
				return;
			}

			this.startLoading();
			try {
				await Promise.all([
					(this.zakazkaEditBaseComponent as any).fetchTableSchema([CAMPAIGN_DETAILS]),
					this.fetchTableData([CAMPAIGN_DETAILS])
				]);

				if (this.dependentTables.Campaign && this.dependentTables.Campaign.rows.length) {
					this.isViewCampaignBtnClicked = true;
					this.viewDialogCampaign = true;
				}
			} finally {
				this.endLoading();
			}
		},
		async saveLabor() {
			this.showDialogConfirmPkg = false;
			if (this.dmsSys.IsCommMode_IsDocConf_Prp) {
				const valid = await (this.zakazkaEditBaseComponent as any).customValidation();
				if (!valid) return;
			}

			try {
				const { data: unavailableParts } = await apiProvider.validateServicePackagePartsInInventory(this.ServicePackageId!, this.VozidloId!);
				if (unavailableParts !== NO_DATA_FOUND) {
					showAlert({
						message: `${unavailableParts} ${this.LocalizeChyboveHlasky('PART_NOT_AVAILABLE')}`,
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;
				}

				this.startLoading();
				if (!this.zakazkaExists) {
					await (this.zakazkaEditBaseComponent as any).changeToEdit();
				} else {
					await (this.zakazkaEditBaseComponent as any).save(false);
				}

				const SP = await apiProvider.createLabor(this.ZakazkaId!, this.ServicePackageId!, this.VozidloId!);
				await apiProvider.createParts(this.ZakazkaId!, this.ServicePackageId!, this.VozidloId!);

				if (!this.ZakazkaId) {
					this.ZakazkaId = SP.data;
				}

				await this.fetchTableData([PRACOVNI_POZICE, ZAKAZKA_ND]);
			} catch (error) {
				this.$store.dispatch(ERROR, { error });
			} finally {
				this.endLoading();
			}
		},
		async saveCampaign() {
			// if (this.isSavingCampaign) {
			// 	return false;
			// }
			this.isSavingCampaign = true;
			this.startLoading();
			try {
				if (this.mandatoryCampaignCount && !this.isMandatoryCampaignSelected()) {
					this.showErrorAlert({ message: 'InvalidCampaign' });
					return false;
				}
				// if (this.isSameCampaignSelected()) {
				// 	this.viewDialogCampaign = false;
				// 	return false;
				// }
				if (!this.isEditMode && this.isCreateMode && (!this.ZakazkaId || this.ZakazkaId < 0)) {
					this.SelectedCampaignId = this.SelectedCampaign;
					this.viewDialogCampaign = false;
					return false;
				}
				if (this.isEditMode && !this.isCreateMode && this.ZakazkaId > 0) {
					this.SelectedCampaignId = null;
					this.SelectedCampaign = this.SelectedCampaign || 0;
					const response = await apiProvider.saveOrUpdateCampaign(this.ZakazkaId, this.SelectedCampaign);
					this.viewDialogCampaign = false;
					if (!response.data) {
						this.showErrorAlert({ message: 'ResponseDataNotFoundAlert' });
					} else {
						this.fetchTableData([ZAKAZKA_ND]);
					}
					return false;
				}
				return true;
			} catch (error) {
				this.$store.dispatch(ERROR, { error });
				return false;
			} finally {
				this.viewDialogCampaign = false;
				this.endLoading();
				this.isSavingCampaign = false;
			}
		},
		async cancelOrRescheduleOrder() {
			const isValid = await this.showConfirmPokracovat(`${this.LocalizeChyboveHlasky('CancelConfirmation')}`, false);
			if (isValid) {
				if (this.Memo) {
					this.startLoading();
					await apiProvider.cancelOrRescheduleOrder(this.ZakazkaId!, 0, this.Memo!);
					await this.mainPageRefresh();
					this.endLoading();
				} else {
					this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('CancelComments');
					this.layoutProps.validationRules = { ...this.layoutProps.validationRules, Memo: { required: true } };
					this.notificationDialog.showNotificationDialog = true;
				}
			}
		},
		async rescheduleOrder() {
			if (this.PmVstupDat === null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('RequiredPlanningDate'),
					title: this.LocalizeChyboveHlasky('RescheduleTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}

			const hotovoDat = dayJs(this.PmVstupDat!);
			const currentDate = dayJs(new Date());
			if (hotovoDat.diff(currentDate, 'millisecond') <= 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('PlanningdateCheck'),
					title: this.LocalizeChyboveHlasky('RescheduleTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (this.Memo) {
				await this.layoutProps.saveClick();
				await apiProvider.rescheduleOrder(this.ZakazkaId!, 0, this.Memo, this.PmVstupDat!);
				const IsGatePassAvailable = await apiProvider.checkGatePass(this.ZakazkaId!);
				this.IsGatePassAvailable = IsGatePassAvailable.data;
				await this.mainPageRefresh();
			} else {
				this.notificationDialog.notificationDialogMsg = this.LocalizeChyboveHlasky('ErrPoznamkaEmpty');
				this.layoutProps.validationRules = { ...this.layoutProps.validationRules, Memo: { required: true } };
				this.notificationDialog.showNotificationDialog = true;
			}
		},
		gatePass() {
			this.tiskDialog.filter = {
				Id: this.ZakazkaId,
				OrderPOrder: true,
				IsCopy: false,
				IsView: false,
				ReportType: 'pdf',
			};
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.getGatePassServisReport(filter);
			this.tiskDialog.visible = true;
		},
		onPreviewClick() {
			if (!this.ReportID) {             
            this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						message: this.LocalizeChyboveHlasky('REPORT_TYPE_MISSING'),
						options: { type: 'info' },
						localizeMessage: false
					});
        return;
      }
			if ([OrderReports.CourtesyCarAgreement, OrderReports.ServiceQuote,
				OrderReports.WorkShopCopy, OrderReports.PartsSalesOrder].includes(this.ReportID! as OrderReports)) {
				this.printReport(this.ReportID!);
			} else {
				this.showReport(this.ReportID!);
			}
		},
		PreviewPopUp() {
			this.showDialog = true;
		},
		async fetchPdfProvider() {
			this.tiskDialog.filter = {
				Id: this.ZakazkaId,
			};
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.getReport(filter, OrderReports.CustomerCopyReport);
		},
		markReportAsPrinted() {
			this.reportType = this.ReportID!;
			if (this.isMarkAsPrint) {
				apiProvider.markReportAsPrinted(this.ZakazkaId, this.reportType);
			}
		},
		async showReport(ReportID: string) {
			const startTime = performance.now();
			this.isMarkAsPrint = true;
			this.tiskDialog.filter = {
				Id: this.ZakazkaId,
			};
			this.tiskDialog.visible = true;
			this.tiskDialog.fetchPdfProvider = async (filter) => {
				const result = await apiProvider.getReport(filter, ReportID);
				let iTotalTimeTaken = performance.now() - startTime;
				let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
				let reportType = this.ReportID === OrderReports.ServiceOrderConfirmationReport ? LOAD_SERVICE_ORDER_CONFIRMATION 
				: this.ReportID === OrderReports.ServiceOrderConfirmationDetailedReport ? LOAD_SERVICE_ORDER_CONFIRMATION_DETAILED 
				: this.ReportID === OrderReports.ServiceOrderConfirmationDetailedCustomerReport ? LOAD_SERVICE_ORDER_CONFIRMATION_DETAILED_CUSTOMER 
				: null;
				if(reportType)
				{
					await apiProvider.logPerformance('OrderPrp', `Order:${this.ZakazkaId}`, reportType, seconds);
				}
				return result;
			};
		},
		async printReport(ReportID: string) {
			this.isMarkAsPrint = true;
			this.tiskDialog.filter = {
				Id: this.ZakazkaId,
				OrderPOrder: true,
				IsCopy: false,
				IsView: false,
				ReportType: 'pdf',
			};
			this.tiskDialog.visible = true;
			this.tiskDialog.fetchPdfProvider = (filter) => apiProvider.getReport(filter, ReportID);
		},

		async taskCreation(orderId: number, taskId: any) {
			await apiProvider.audatexGetTask(orderId, taskId);
		},
		async onAudatexOptionSelected() {
			this.startLoading();
			this.isAudaTexVisible = false;

			if (this.lblAudatex === AUDATEX_OPTIONS.SEND_TO_AUDATEX) {
				await apiProvider.audatexCreatTask(this.edit);
			} else if (this.lblAudatex === AUDATEX_OPTIONS.DOWNLOAD_RESULT_FROM_AUDATEX) {
				await apiProvider.audatexGetTask(this.edit.ZakazkaId, '');
			} else if (this.lblAudatex === AUDATEX_OPTIONS.RETRIEVE_AUDATEX_TASK_LIST) {
				await openSelectList(
					AUDATEX,
					{
						filter: {
							Vin: this.edit.VozidloVin,
							OrderId: this.edit.ZakazkaId,
						},
						afterRowSelection: ({ row }) => {
							this.taskCreation(this.edit.ZakazkaId, row.ID);
						},
					},
				);
			} else {
				return;
			}
			this.endLoading();
		},
		isCampaignDisabled(row: any): boolean {
			return this.mandatoryCampaignCount > 0 && row.CAMPAIGN_CATEGORY === OPTIONAL_CAMPAIGN;
		},
		onCampaignRowSelection(row: any) {
			if (row && !this.isCampaignDisabled(row)) {
				this.SelectedCampaign = row.ID;
			}
		},
		onCampaignRowDeselect(event: Event, row: any) {
			if (row) {
				this.SelectedCampaign = null;
				event.stopPropagation();
			}
		},
		getFormattedDate(date: string): string | null {
			return formatDate(date);
		},
		isOptionalCampaignSelected(row: any): boolean {
			return this.isCampaignSelected(row) && row.CAMPAIGN_CATEGORY === OPTIONAL_CAMPAIGN;
		},
		isCampaignSelected(row: any): boolean {
			return this.SelectedCampaign === row.ID;
		},
		isMandatoryCampaignSelected(): boolean {
			return !!this.mandatoryCampaignCount && this.CampaignTable.some(x => x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN && this.isCampaignSelected(x));
		},
		isSameCampaignSelected(): boolean {
			return this.CampaignTable.some(x => x.IsSelected === true && this.isCampaignSelected(x));
		},
		isMandatoryCampaignSaved(): boolean {
			return this.CampaignTable.some(x => x.IsSelected === true && x.CAMPAIGN_CATEGORY === MANDATORY_CAMPAIGN);
		},
		async onIssueClick() {
			if (this.lbleGUI === EGUI_OPTIONS.EGUI_ISSUE) {
				this.iseGUIIssuePopUpVisible = true;
			}
		},
		async oneGUIOptionSelected() {
			this.iseGUIVisible = false;
			this.iseGUIIssuePopUpVisible = false;

			switch (this.lbleGUI) {
				case EGUI_OPTIONS.EGUI_PRINT:
				case EGUI_OPTIONS.EGUI_CANCEL:
					break;
				default:
					this.showErrorAlert({
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						message: this.LocalizeChyboveHlasky('eGUIOptionSelect'),
						options: { type: 'info' },
						localizeMessage: false,
					});
					return;
			}
			if ((this.EGUIInvoiceNumber === '' || this.EGUIInvoiceNumber === null) && (this.lbleGUI === EGUI_OPTIONS.EGUI_PRINT || this.lbleGUI === EGUI_OPTIONS.EGUI_CANCEL)) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					message: this.LocalizeChyboveHlasky('eGUIIssueFirst'),
					options: { type: 'info' },
					localizeMessage: false,
				});
				return;
			}
			if (this.lbleGUI === EGUI_OPTIONS.EGUI_PRINT) {
				this.eGUIPrintInvoice();
			} else if (this.lbleGUI === EGUI_OPTIONS.EGUI_CANCEL) {
				this.eGUICancelInvoice();
			}
		},
		async eGUICancelInvoice() {
			this.startLoading();
			const eGUICancelInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
			};
			const response = await apiProvider.eGUICancelInvoice(eGUICancelInvoiceRequestDTO);
			this.endLoading();
			if (response !== null && response.RtnCode > 0) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					message: `${this.LocalizeChyboveHlasky('eGUICancelSuccess')} ${'Invoice No:'} ${response.InvoiceNo}`,
					options: { type: 'info' },
					localizeMessage: false,
				});
			} else {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: this.LocalizeChyboveHlasky('eGUICancelFail'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
		},
		async eGUIPrintInvoice() {
			this.startLoading();
			const eGUIPrintInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
			};
			const { data: response } = await apiProvider.eGUIPrintInvoice(eGUIPrintInvoiceRequestDTO);
			this.endLoading();
			if (response !== null && response !== '' && response.RtnCode === 1) { // success
				const invoiceItems = response?.InvoiceHtmlForSplit.split(',');
				for (let iItem = 0; iItem < invoiceItems.length; iItem++) {
					window.open(invoiceItems[iItem], '_blank');
				}
				if (response.RtnMsg == '查無資料' && response?.CarrierFailedEguiNumbers?.length > 0) {
					const eguiList = response.CarrierFailedEguiNumbers.join(', ');
					this.showErrorAlert({
						title: '',
						message: `${this.LocalizeChyboveHlasky('printingNotAllowed')}${eguiList}`,
						options: { type: 'info' },
					});
				}
			} else if (response.RtnCode === EGUI_OPTIONS.EGUI_RTN_CODE) {
				const eguiList = response?.CarrierFailedEguiNumbers?.length ? response.CarrierFailedEguiNumbers.join(', ') : '';
				this.showErrorAlert({
					title: '',
					message: `${this.LocalizeChyboveHlasky('printingNotAllowed')}${eguiList}`,
					options: { type: 'info' },
					localizeMessage: false,
				});
			} else {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: this.LocalizeChyboveHlasky('eGUIPrintFail'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
		},
		async AssignWorkshopOrder() {
			this.startLoading();
			await apiProvider.AssignWorkshopOrder(this.ZakazkaId);
			this.endLoading();
		},
		async GetWorkshopOrder() {
			if(!this.CanAddPartOrLabour) {
				showAlert({
						message: this.LocalizeChyboveHlasky('CANNOT_ADD_NEW_ITEM'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
			}
			this.startLoading();
			await apiProvider.GetWorkshopOrder(this.ZakazkaId);
			await this.fetchTableData([ZAKAZKA_ND, PRACOVNI_POZICE]);
			await this.mainPageRefresh();

			const { data: isLaborInProgress } = await apiProvider.isLaborInProgress(this.ZakazkaId);
			if (isLaborInProgress) {
				const proceedWithSave = await this.showConfirm({
					message: this.LocalizeChyboveHlasky('LABOR_IN_PROGRESS_VALIDATION'),
					title: this.LocalizeChyboveHlasky('questionTitle'),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (proceedWithSave) {
					const response = await apiProvider.assignLaborOperations(this.ZakazkaId);
					await this.fetchTableData([PRACOVNI_POZICE]);
					if (response?.data) {
						let displayMessage: string;
						if (response.data === 'WMS_CHIP_VAL') {
							displayMessage = this.LocalizeChyboveHlasky('WMS_CHIP_VAL');
						} else if (response.data === 'WMS_CHIP_OVERLAP_VAL') {
							displayMessage = this.LocalizeChyboveHlasky('WMS_CHIP_OVERLAP_VAL');
						} else {
							displayMessage = response.data + ' ' + this.LocalizeChyboveHlasky('IGNORED_LABOR_ASSIGNMENT');
						}

						showAlert({
							message: displayMessage,
							title: 'Notification',
							options: {
								type: 'info',
							},
						});
					}
				} else {
					await apiProvider.autoAssignCancelled(this.ZakazkaId);
				}
			}

			this.endLoading();
		},
		async getCustomerByGoldenAccountId() {
			this.startLoading();
			const response = await apiProvider.getCustomerByGoldenAccountId(this.ZakaznikId, this.VozidloVin, CustomerVehicleRefresh.ORDER);
			
			await this.GetOrderContactDetails(this.ZakazkaId, true);
			await this.mainPageRefresh();
			if (response?.data?.Value) {				
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					message: this.LocalizeChyboveHlasky('DataSyncSuccess'),
					options: { type: 'info' },
				});
			}
			this.endLoading();
		},
		async GetOrderContactDetails(orderId: number, isServiceOrder: boolean) {
			const { data } = await apiProvider.GetOrderContactDetails(orderId, isServiceOrder);
			this.SelectedCustomerContactDetail = data && data.length > 0 ? data[0] : null;
			this.ContactTypeId = this.SelectedCustomerContactDetail ? this.SelectedCustomerContactDetail.ContactTypeId : null;
		}
	},
});
